<template>
  <div>
    <!-- BEGIN panel -->

    <div class="mb-3" style="display: flex; justify-content: space-between;;">
      <div class="btn-group">
        <button @click="() => { this.order = 'id'; fetchData(1) }" class="btn btn-white"
          :class="{ active: this.order == 'id' }">Все</button>
        <button @click="() => { this.order = 'rating'; fetchData(1) }" class="btn btn-white"
          :class="{ active: this.order == 'rating' }">Лучшие</button>
        <button @click="() => { this.order = 'price'; fetchData(1) }" class="btn btn-white"
          :class="{ active: this.order == 'price' }">Цена</button>
      </div>
      <button @click="$router.push({ name: 'TaskCreate' })" class="btn btn-primary">Добавить <span
          class="hide-450">задание</span></button>
    </div>
    <p>
      <v-select placeholder="Выбрать тип задания" v-model="tags" :options='[
            { code: "NETWORKS", name: "Соцсети" }, { code: "CLICK", name: "Клики" }, { code: "SURFING", name: "Серфинг" }, { code: "AVITO", name: "Авито" }, { code: "MESSENGER", name: "Мессенджеры" },
            { code: "POSTING", name: "Постинг, статьи" }, { code: "APPLICATION", name: "Установка приложений" },
            { code: "REGACT", name: "Регистрация с активностью" }, { code: "REGNOACT", name: "Регистрация без активности" }
          ]' :reduce="tag => tag.code" label="name" multiple @input="fetchDataDebounce(1)" />
    </p>
    <div class="alert alert-info fade show">
      <small> Бесплатные лайки и подписчики
        <a href="https://fastfreelikes.com" target="_blank"><b>ВКонтакте</b></a> </small>
    </div>

    <div v-if="user.rating >= 0" class="alert alert-secondary fade show">
      <small> Ваш текущий <a href="/#/rating">рейтиг</a>: <b>{{ user.rating }}</b> Если рекламодатель отказывает в
        выплате,
        Ваш рейтинг падает. Чем выше ваш рейтинг тем больше заданий вам будет доступно. Пожалуйста, старайтесь выполнять
        задания качественно и вовремя </small>
    </div>
    <div v-if="user.rating < 0" class="alert alert-warning fade show">
      <small> Ваш текущий <a href="/#/rating">рейтиг</a>: <b>{{ user.rating }}</b> Чем выше ваш рейтинг тем больше
        заданий
        вам будет доступно. Пожалуйста, старайтесь выполнять задания качественно и вовремя</small>
    </div>
    <div v-show="!jobs.length" class="text-center pt-5">
      <h3> Задания не найдены</h3>
    </div>
    <div v-if="message" class="text-center pt-5">
      <p> {{ message }}</p>
    </div>

    <div class="card  border-0 mb-3" v-for="(job, index)  in 					jobs" :key="index">
      <JobPanel :job="job">
      </JobPanel>
      <div class="card-footer">
        <div class="d-flex justify-content-between" style="display: flex;justify-content: right;">
          <div>
            <div class="btn btn-white">
              <span class="text-success" v-b-tooltip.hover title="Выполнено">{{ job.done }}</span>
              <span>•</span>
              <span v-b-tooltip.hover title="На проверке">{{ job.in_review }}</span>
              <span>•</span>
              <span class="text-danger" v-b-tooltip.hover title="Количество обращений в арбитраж исполнителями">{{
            job.arbitrage }}</span>
            </div>
          </div>
          <div>
            <button @click="hideJob(job.id)" class="btn btn-white me-2"> <i class="fas fa-eye-slash"></i>
              <span class="hide-450 ms-1">Скрыть</span></button>
            <a :href="`/#/job/${job.id}/show`" target="_blank" class="btn btn-white"><i class="fas  fa-circle-play"></i>
              <span class="hide-450 ms-1">Выполнить</span></a>
          </div>
        </div>
      </div>
    </div>
    <Paginator :meta="meta" :fetchData="fetchData" />
    <!-- END panel -->
  </div>
</template>


<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";
import debounce from 'lodash.debounce'

export default {
  data() {
    return {
      loading: false,
      jobs: [],
      order: '',
      curr_page: 1,
      meta: {last_page: 1},
      tags: '',
      message: null,
      user: null
    };
  },
  watch: {
    '$route'() {
      this.tags = localStorage.getItem('tags')
      if (!this.tags) {
        this.tags = ['NETWORKS', 'CLICK', 'MESSENGER', 'POSTING', 'APPLICATION', 'REGACT', 'REGNOACT']
      } else {
        this.tags = this.tags.split(',')
      }
      this.order = localStorage.getItem('order')
      if (!this.order || this.order == '') {
        this.order = 'rating'
      }
      let page = localStorage.getItem('page');
      this.fetchData(page);
    }
  },

  created() {
    this.tags = localStorage.getItem('tags')
    /*
    if (!this.tags) {
      this.tags = ['NETWORKS', 'CLICK', 'MESSENGER', 'POSTING', 'AVITO', 'APPLICATION', 'REGACT', 'REGNOACT']
    } else {
      this.tags = this.tags.split(',')
    }
    */
    this.tags = ['NETWORKS', 'CLICK', 'SURFING', 'MESSENGER', 'POSTING', 'AVITO', 'APPLICATION', 'REGACT', 'REGNOACT']
    this.order = localStorage.getItem('order')
    if (!this.order || this.order == '') {
      this.order = 'id'
    }
    let page = localStorage.getItem('page');
    this.fetchData(page);
  },


  methods: {
    myclick() {
      console.log('tags', this.tags)
    },
    hideJob(id) {
      HTTP()
        .put(`job/${id}?hide`)
        .then((response) => {
          console.log(response);
          this.fetchData();
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        });
    },
    removeTask(id) {
      if (confirm("Вы уверены? ")) {
        HTTP()
          .delete("v2/task/" + id)
          .then((response) => {
            console.log(response);
            show_message(this.$notify, response.data);
            this.fetchData();
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          });
      }
      return;
    },
    fetchDataDebounce: debounce(function (page) {
      this.fetchData(page)
    }, 1500),
    fetchData(page) {
      localStorage.setItem('tags', this.tags)
      localStorage.setItem('order', this.order)
      localStorage.setItem('page', page)
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get(`/job?status=${this.$route.params.status}&order=${this.order}&page=${page}&types=${this.tags}`)
        .then((resp) => {
          console.log('resp', resp)
          this.jobs = resp.data.data
          this.user = resp.data.user
          this.meta = resp.data.meta
          this.message = resp.data.message
          this.meta.current_page = !this.meta.current_page ? 1 : this.meta.current_page
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          window.eventBus.$emit('user.update', resp.data.user)
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    }
  }
}
</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}

@media (max-width: 450px) {
  .hide-450 {
    display: none;
  }
}

.vs__selected {
  height: 30px;
  padding-left: 10px;
}

.vs__selected .vs__deselect {
  padding-left: 5px;
  padding-right: 6px;
}

.vs__dropdown-toggle {
  background-color: var(--app-component-bg);
}

.vs__dropdown-menu {
  background-color: var(--app-component-bg);
}

.vs__selected {
  background-color: var(--app-component-table-border-color);
  color: var(--app-component-color);
}

.vs__deselect {
  fill: var(--app-component-color);
}

.vs__open-indicator {
  fill: var(--app-component-color);
}
</style>